import * as React from "react";

import {useAppDispatch} from "../../redux/storeHooks";
import {EBook} from "./eLibrarySlice";
import {downloadBook} from "./eBookFunctions";
import {useState} from "react";
import Loader from "../ui/Loader";


const EBookItem = (props: {eBook: EBook}) => {

  const {eBook} = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  const dispatch = useAppDispatch();

  return (
    <li className={"member-book" + (imageLoaded ? "" : " member-book--loading")}
        key={eBook.title}
        onClick={() => downloadBook(eBook, dispatch)}>
      {imageLoaded ? null : <Loader/>}
      <img src={eBook.image} className="member-book__image" alt={eBook.title} onLoad={() => setImageLoaded(true)} />
      <div className="member-book__card">
        <span className="member-book__card-title">{eBook.title}</span>
        <span className="member-book__card-description">{eBook.description}</span>
      </div>
    </li>
  )
}

export default EBookItem
